import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { useGET_rtiRiskCriteriaThreeListQuery } from 'redux/api/rtiApi'
import { IStudent } from "types"
import MainTable from "components/organisms/tables/MainTable"
import { useTableModel } from 'utils/tableModels/useRtiRiskCriteriaThreeTableModel'
import { Button, Tooltip } from '@mui/material'
import { Add } from '@mui/icons-material'
import { useTranslation } from "react-i18next"
import { removeEmpty } from "utils/helpers"

interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const RtiConcernReasonsList: FC<IProps> = ({ student }) => {
    
    const { t } = useTranslation()
    const navigate  =  useNavigate()

    const filters = {
        student: student.student_profile_id
    }

    return <> 
       <MainTable
            useTableModel={useTableModel}
            getTableData={ useGET_rtiRiskCriteriaThreeListQuery}
            tableRowParams={ {'sid': student.id} }
            filters={removeEmpty(filters)}
            header={<div style={{ textAlign: 'right', paddingBottom: '10px' }}>

                  <Tooltip title={`${t('common.add-concern-reason')}`} arrow placement='top'>
                    <Button
                        variant='contained'
                        color='success'
                        aria-haspopup='true'
                        onClick={() => navigate(`/rti-concerns/add?student_id=${student.id}`)}
                        disableElevation
                        sx={{ 
                            lineHeight: '1rem'
                        }}
                    >
                        <Add />                         
                        <span>{`${t('common.add-concern-reason')}`}</span>
                    </Button>
                </Tooltip>
                
            </div>}
       />    
    </>
}
export default RtiConcernReasonsList